import { AppData, Lightning, Utils } from "@lightningjs/sdk";
import { AppSetup } from "../lib/app-setup";

export interface LiveHeaderTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Background: object;
    BackButton: object;
    Logo: object;
}

export default class LiveHeader extends Lightning.Component<LiveHeaderTemplateSpec> {
    static override _template(): Lightning.Component.Template<LiveHeaderTemplateSpec> {
        return {
            w: 1920,
            h: 150,
            Background: {
                w: 1920,
                h: 517,
                x: 0,
                y: 0,
                rect: true,
                colorTop: 0xE60D0D1D,
                colorBottom: 0x000D0D1D,
            },
            BackButton: {
                x: 56,
                y: 69,
                collision: true,
                texture: {
                    src: Utils.asset('images/ico-back.png'),
                    resizeMode: { h: 52, w: 52, type: 'contain' },
                    type: Lightning.textures.ImageTexture
                }
            },
            Logo: {
                x: 136,
                y: 66,
                w: 450,
                h: 60,
            }
        };
    }

    override _firstActive() {
        this._updateLogo();
    }

    _handleClick() {
        this.fireAncestors('$onHeaderBackClick')
    }
    _updateLogo() {
        const { appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        if (appApiConfig?.appBrandConfig?.header_logo) {
            this.tag('Logo').patch({
                texture: {
                    src: appApiConfig.appBrandConfig.header_logo,
                    resizeMode: {
                        h: 60,
                        w: 450,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                }
            });
        }
    }
}